<template>
    <div class="inline-block botao-editor-container">
        <Button
            label="Secondary"
            severity="secondary"
            :class="[botaoClasses, { 'p-button-rounded': arredondamento === 'rounded' }, { 'p-button-silhueta': silhueta === 'outlined' }]"
            :style="botaoStyles"
            class="inline-flex align-items-center justify-content-center gap-2 no-underline border-2 border-transparent font-medium transition-all transition-duration-300 text-center w-full"
            @click="!isEditor ? executarAcao : () => {}"
        >
            <i v-if="iconeRedeSocial" :class="iconeRedeSocial" style="font-size: 1.5rem; margin-right: 0.5rem"></i>
            <span
                v-if="icone && !iconeRedeSocial"
                class="material-symbols-outlined"
                :class="{ 'text-sm': tamanho === 'pequeno', 'text-base': tamanho === 'medio', 'text-lg': tamanho === 'grande' }"
                style="margin-right: 0.5rem"
                >{{ icone }}</span
            >
            {{ texto }}
        </Button>
        <slot name="overlaySelecao" />
    </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import Button from 'primevue/button';
import { useEditorLandingPage } from '@/composables/useEditorLandingPage';
import { TAMANHOS_BOTAO, CLASSES_DESABILITADO, CLASSE_LARGURA_COMPLETA, CLASSE_ARREDONDADO, CLASSE_PADRAO } from '@/utils/estilosBotoes';

const props = defineProps({
    texto: {
        type: String,
        default: 'Clique aqui',
    },
    link: {
        type: String,
        default: '#',
    },
    acao: {
        type: String,
        default: 'link',
    },
    abrirNovaAba: {
        type: Boolean,
        default: false,
    },
    estilo: {
        type: String,
        default: 'primario',
        validator: (value) => ['primario', 'secundario', 'sucesso', 'perigo', 'aviso', 'info'].includes(value),
    },
    tamanho: {
        type: String,
        default: 'medio',
        validator: (value) => ['pequeno', 'medio', 'grande'].includes(value),
    },
    larguraCompleta: {
        type: Boolean,
        default: false,
    },
    icone: {
        type: String,
        default: '',
    },
    desabilitado: {
        type: Boolean,
        default: false,
    },
    arredondamento: {
        type: String,
        default: 'raised',
    },
    boxShadow: String,
    cor: {
        type: String,
        default: '#1097C6',
    },
    silhueta: {
        type: String,
    },
    acaoBotao: {
        type: String,
        default: 'link',
    },
    isEditor: {
        type: Boolean,
        default: false,
    },
    alinhamento: {
        type: String,
        default: 'start',
    },
});

const { limparCamposFormulario } = useEditorLandingPage();

const executarAcao = () => {
    if (props.acaoBotao === 'limpar') {
        limparCamposFormulario();
    }
};

const botaoClasses = computed(() => {
    const classes = [];

    classes.push(...(TAMANHOS_BOTAO[props.tamanho] || TAMANHOS_BOTAO.medio));

    if (props.larguraCompleta) {
        classes.push(CLASSE_LARGURA_COMPLETA);
    }

    if (props.desabilitado) {
        classes.push(...CLASSES_DESABILITADO);
    }

    classes.push(props.arredondado ? CLASSE_ARREDONDADO : CLASSE_PADRAO);
    return classes;
});

const iconeRedeSocial = computed(() => {
    switch (props.acao) {
        case 'instagram':
            return 'pi pi-instagram';
        case 'linkedin':
            return 'pi pi-linkedin';
        case 'twitter':
            return 'pi pi-twitter';
        case 'facebook':
            return 'pi pi-facebook';
        default:
            return null;
    }
});

const isColorLight = (color) => {
    const hex = color.replace('#', '');

    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    // Calcula a luminância usando a fórmula padrão
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    return luminance > 0.5;
};

const botaoStyles = computed(() => {
    const styles = {
        boxShadow: props.boxShadow,
        pointerEvents: props.isEditor ? 'none' : 'auto',
    };

    if (props.silhueta === 'outlined') {
        styles.backgroundColor = 'transparent !important';
        styles.borderColor = props.cor + ' !important';
        styles.color = props.cor;
    } else {
        styles.backgroundColor = props.cor + ' !important';
        styles.borderColor = 'transparent !important';
        styles.color = isColorLight(props.cor) ? '#000000' : '#ffffff';
    }

    return styles;
});
</script>

<style scoped>
.hover\:bg-blue-600:hover {
    background-color: #2563eb !important;
}

.hover\:bg-blue-500:hover {
    background-color: #3b82f6 !important;
}

.hover\:bg-green-600:hover {
    background-color: #16a34a !important;
}

.hover\:bg-red-600:hover {
    background-color: #dc2626 !important;
}

.hover\:bg-yellow-600:hover {
    background-color: #ca8a04 !important;
}

.hover\:text-white:hover {
    color: white !important;
}

a:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

a:active {
    transform: translateY(0);
}
.p-button-silhueta {
    border-width: 3px !important;
}
</style>